import { ReactNode } from 'react';

interface HeaderProps {
  children: ReactNode;
}

export function Header({ children }: HeaderProps) {
  return (
    <header
      className={`
        sticky top-0 
        before:absolute before:inset-0 before:backdrop-blur-md 
        before:bg-white 
        before:-z-10 z-30
        after:absolute after:h-px after:inset-x-0 after:top-full after:bg-gray-200 dark:after:bg-gray-700/60 after:-z-10
        dark:before:bg-gray-900
        max-lg:before:bg-white/90 dark:max-lg:before:bg-gray-800/90
      `}
    >
      <div className="px-4 sm:px-6 lg:px-8 relative">
        <div className="flex items-center justify-between h-16">{children}</div>
      </div>
    </header>
  );
}
